import React, { useState, useContext } from "react";
import { Button } from "@mui/material";
import { 
  HeaderContainer,
  Logo as StyledLogo,
  MenuContainer,
  KavidaImg,
  DescriptionContainer,
  Heading,
  SupplierPortalHeading,
  ContentDescription,
  SupplierContentDescription,
  PlatformBtn,
  SkipBtnContainer,
  ViewNextBtn,
  LeftArrow,
  SkipText
} from "./OnboardingStyle.js";
import Logo from "../../assets/images/kavida-logo.svg";
import KavidaLogo from "../../assets/images/k-logo.svg";
import KavidaGreyLogo from "../../assets/images/kavida-grey-logo.svg";
import ErpLogo from "../../assets/images/integration-logo.svg";
import Erp from "../../assets/images/erp-logo.svg";
import Users from "../../assets/images/profile-user.svg";
import Message from "../../assets/images/message.svg";
import SupplierPortal from "../../assets/images/supplier-portal.svg";
import RightArrow from "../../assets/images/right-arrow.svg";
import PurchaseOrder from "../../assets/images/purchase-order-grp.png";
import ERP from "../../assets/images/ERP-grp.png";
import Communication from "../../assets/images/Communication-grp.png";
import SupplierPortalGrp from "../../assets/images/supplier-portal-grp.png";
import { UJFirstTimeLogin } from "../../services/api.service.js";
import { appContext } from "../../states/context/appContext";

export default function OnboardingComponent() {
  const [menu, setMenu] = useState("kavida");
  const globalContext = useContext(appContext);

  const handleNavigation = () => {
    ujCheckFirstSession();
  };

  const ujCheckFirstSession = async () => {
    try {
      const firstTimeLoginData = {
        api_name: "uj_check_first_session",
        data: {},
      };
      await UJFirstTimeLogin(firstTimeLoginData);
      globalContext.setIsFirstTimeLogin(false);
    } catch (e) {
      console.log(e);
    }
  };
  const handleMenu = (menu) => {
    setMenu(menu);
  };
  const handleViewNext = (menu) => {
    window.scrollTo(0,0);
    setMenu(menu);
  };
  return (
    <>
             <HeaderContainer>
         <StyledLogo src={Logo} />
       </HeaderContainer>
       <div
         className="welcome-main-container"
         style={{
           backgroundColor: "#ffffff",
           display: "flex",
           flexDirection: "row",
           justifyContent: "center",
           height: "100vh",
         }}
       >
         <MenuContainer className="res-menu-container">
           <span
             onClick={() => handleMenu("kavida")}
             style={{
               background: menu == "kavida" ? "#FAFAFA" : "#fff",
               boxShadow:
                 menu == "kavida"
                   ? "inset 0px 3px 8px #00000008, 0px 3px 24px #00000000"
                   : "none",
               border: menu == "kavida" ? "2px solid #E5E5E9" : "none",
               borderRadius: "8px",
               width: "90%",
               padding: "8px",
               display: "flex",
               marginTop: "10%",
               cursor: "pointer",
             }}
           >
             <KavidaImg
               className="menu-icon"
               src={menu == "kavida" ? KavidaLogo : KavidaGreyLogo}
               alt=""
             />
             <span
               style={{
                 color: menu == "kavida" ? "#6361EE" : "#7F7D94",
                 fontWeight: 600,
                 fontSize: "14px",
                 fontFamily: "Sora",
                 padding: "7px",
               }}
             >
               Purchase orders
             </span>
           </span>

           {/* Continue with ERP menu item */}
           <span
             onClick={() => handleMenu("erp")}
             style={{
               background: menu == "erp" ? "#FAFAFA" : "#fff",
               boxShadow:
                 menu == "erp"
                   ? "inset 0px 3px 8px #00000008, 0px 3px 24px #00000000"
                   : "none",
               border: menu == "erp" ? "2px solid #E5E5E9" : "none",
               borderRadius: "8px",
               width: "90%",
               padding: "8px",
               display: "flex",
               marginTop: "10%",
               cursor: "pointer",
             }}
           >
             <img
               className="menu-icon"
               src={menu == "erp" ? ErpLogo : Erp}
               alt=""
             />
             <span
               style={{
                 color: menu == "erp" ? "#6361EE" : "#7F7D94",
                 fontWeight: 600,
                 fontSize: "14px",
                 fontFamily: "Sora",
                 padding: "7px",
               }}
             >
               ERP integrations
             </span>
           </span>

           {/* Continue with Communication menu item */}
           <span
             onClick={() => handleMenu("communication")}
             style={{
               background: menu == "communication" ? "#FAFAFA" : "#fff",
               boxShadow:
                 menu == "communication"
                   ? "inset 0px 3px 8px #00000008, 0px 3px 24px #00000000"
                   : "none",
               border: menu == "communication" ? "2px solid #E5E5E9" : "none",
               borderRadius: "8px",
               width: "90%",
               padding: "8px",
               display: "flex",
               marginTop: "10%",
               cursor: "pointer",
             }}
           >
             <img
               className="menu-icon"
               src={menu == "communication" ? Users : Message}
               alt=""
             />
             <span
               style={{
                 color: menu == "communication" ? "#6361EE" : "#7F7D94",
                 fontWeight: 600,
                 fontSize: "14px",
                 fontFamily: "Sora",
                 padding: "7px",
               }}
             >
               Communication
             </span>
           </span>

           {/* Continue with Supplier Portal menu item */}
           <span
             onClick={() => handleMenu("supplierPortal")}
             style={{
               background: menu == "supplierPortal" ? "#FAFAFA" : "#fff",
               boxShadow:
                 menu == "supplierPortal"
                   ? "inset 0px 3px 8px #00000008, 0px 3px 24px #00000000"
                   : "none",
               border: menu == "supplierPortal" ? "2px solid #E5E5E9" : "none",
               borderRadius: "8px",
               width: "90%",
               padding: "8px",
               display: "flex",
               marginTop: "10%",
               cursor: "pointer",
             }}
           >
             <img
               className="menu-icon"
               src={SupplierPortal}
               alt=""
             />
             <span
               style={{
                 color: menu == "supplierPortal" ? "#6361EE" : "#7F7D94",
                 fontWeight: 600,
                 fontSize: "14px",
                 fontFamily: "Sora",
                 padding: "7px",
               }}
             >
               Supplier portals
             </span>
           </span>
         </MenuContainer>
         <div className="right-container">
           <DescriptionContainer className="description-container">
             {menu == "kavida" ? (
               <Heading className="tab-heading">
                 Hi there, <br className="desktop-view" /> welcome to Kavida
               </Heading>
             ) : menu == "erp" ? (
               <Heading className="tab-heading">
                 Plug into your existing <br className="desktop-view" /> ERP
               </Heading>
             ) : menu == "communication" ? (
               <Heading className="tab-heading">
                 Streamline supplier <br className="desktop-view" /> communication
               </Heading>
             ) : menu == "supplierPortal" ? (
               <SupplierPortalHeading className="tab-heading">
                 Better collaboration with <br className="desktop-view" /> supplier portals
               </SupplierPortalHeading>
             ) : null}
             
             {menu == "kavida" ? (
               <>
                 <ContentDescription className='margin-top-2-percent'>
                   Kavida helps procurement teams <br className="mobile-view" /> collaborate with
                   <br className="desktop-view" /> their suppliers, track order <br className="mobile-view" /> updates and detect delays{" "}
                   <br className="desktop-view" />
                   to delivery dates.
                 </ContentDescription>
                 <ContentDescription>
                   Let's spend a few minutes to walk through <br className="mobile-view" /> how you can <br className="desktop-view" /> use Kavida as your go-to order <br className="mobile-view" /> management platform.
                 </ContentDescription>
               </>
             ) : menu == "erp" ? (
               <>
                 <ContentDescription className='margin-top-2-percent'>
                   Easily connect Kavida with your current <br className="mobile-view" /> ERP. When you <br className="desktop-view" /> raise an
                   order, Kavida syncs <br className="mobile-view" /> the data, manages the order <br className="desktop-view" /> and sends all <br className="mobile-view" />
                   updates right to your ERP.
                 </ContentDescription>
                 <ContentDescription>
                   Don't have an ERP? Just upload a <br className="mobile-view" /> spreadsheet with your <br className="desktop-view" /> order
                   and supplier <br className="mobile-view" /> information - and we'll handle the rest.
                 </ContentDescription>
               </>
             ) : menu == "communication" ? (
               <>
                 <ContentDescription className='margin-top-2-percent'>
                   Link your email so you can centralize all <br className="mobile-view" /> order  <br className="desktop-view" /> communications
                   in one platform.
                 </ContentDescription>
                 <ContentDescription>
                   Automate supplier follow ups, missing <br className="mobile-view" /> document  <br className="desktop-view" /> requests and be aligned on your <br className="mobile-view" /> production schedules.
                 </ContentDescription>
               </>
             ) : menu == "supplierPortal" ? (
               <>
                 <SupplierContentDescription className='margin-top-2-percent'>
                   A dedicated portal to collaborate with every <br className="mobile-view" /> supplier,  <br className="desktop-view" />
                   ensuring you're both on the same <br className="mobile-view" /> page with delivery  <br className="desktop-view" /> dates,
                   documents, and <br className="mobile-view" /> production timelines.
                 </SupplierContentDescription>
                 <SupplierContentDescription>
                   Combined with an order chat to <br className="mobile-view" /> communicate -  <br className="desktop-view" />with in-built
                   options that <br className="mobile-view" /> lets you request and review  <br className="desktop-view" /> delivery dates <br className="mobile-view" /> and
                   order documents.
                 </SupplierContentDescription>
               </>
             ) : null}

             {menu == "supplierPortal" && (
               <PlatformBtn
                 onClick={() => handleNavigation()}
                 variant="contained"
                 className="platform-btn"
               >
                 <span style={{ fontFamily: "Figtree" }}>Let's get started </span>
                 <i
                   style={{ fontSize: "20px", paddingLeft: "5px" }}
                   className="fa-regular fa-circle-check"
                 ></i>
               </PlatformBtn>
             )}

             <SkipBtnContainer>
               {menu == "kavida" ? (
                 <>
                   <ViewNextBtn
                     onClick={() => handleViewNext("erp")}
                     variant="contained"
                     className="view-next-btn"
                   >
                     <span style={{ fontFamily: "Figtree" }}>View Next </span>
                     <LeftArrow src={RightArrow} />
                   </ViewNextBtn>
                   <SkipText
                     onClick={() => handleNavigation()}
                     className="skip-text"
                   >
                     Skip
                   </SkipText>
                 </>
               ) : menu == "erp" ? (
                 <>
                   <ViewNextBtn
                     onClick={() => handleViewNext("communication")}
                     variant="contained"
                     className="view-next-btn"
                   >
                     <span style={{ fontFamily: "Figtree" }}>View Next </span>
                     <LeftArrow src={RightArrow} />
                   </ViewNextBtn>
                   <SkipText
                     onClick={() => handleNavigation()}
                     className="skip-text"
                   >
                     Skip
                   </SkipText>
                 </>
               ) : menu == "communication" ? (
                 <>
                   <ViewNextBtn
                     onClick={() => handleViewNext("supplierPortal")}
                     variant="contained"
                     className="view-next-btn"
                   >
                     <span style={{ fontFamily: "Figtree" }}>View Next </span>
                     <LeftArrow src={RightArrow} />
                   </ViewNextBtn>
                   <SkipText
                     onClick={() => handleNavigation()}
                     className="skip-text"
                   >
                     Skip
                   </SkipText>
                 </>
               ) : null}
             </SkipBtnContainer>
           </DescriptionContainer>
          <div
            className="purchase-order-img"
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "-3%",
              marginTop: "3%",
              width: "46%",
            }}
          >
            <img
              src={
                menu == "kavida"
                  ? PurchaseOrder
                  : menu == "erp"
                  ? ERP
                  : menu == "communication"
                  ? Communication
                  : menu == "supplierPortal"
                  ? SupplierPortalGrp
                  : null
              }
            />
          </div>
        </div>
        <div className="warning-block">
          <i
            className="fa fa-exclamation-circle warning-fa-fa"
            aria-hidden="true"
          ></i>
          <span className="warning-caption">
            For a better user experience, we recommend using your desktop{" "}
          </span>
        </div>
      </div>
    </>
  );
}
